<div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let item of dataType">
        <div class="box" (click)="chooseSubject(item.id)">
            <p class="box__name pl-1">{{item?.name}}</p>
            <p class="box__desc">{{item?.description}}</p>
        </div>
    </div>
</div>